<template>
  <section>
    <div class="customBlockWrapper">
      <div class="customBlockCnt" v-if="section.code && section.code[lang]" v-html="section.code[lang]"></div>
      <div class="customBlockCnt noImg" v-else></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'customBlock',
  props: ['section'],
  components: {},
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.customBlockCnt{
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  &.noImg{
    background-color: #ccc;
    background-image: url(../../assets/embed-code-wide.png);
    background-size: 54px auto;
    background-position: center;
    background-repeat: no-repeat;
    height: 240px;
    opacity: .36;
  }
}
</style>
